import styled from 'styled-components'

const Title = styled.div`
  color: #fff;
  padding: 5px 15px;
  max-width: 200px;
  background-color: rgba(0, 0, 0, 0.6);
  font-weight: normal;
  font-size: 30px;
  letter-spacing: -1;
  & p {
    color: #fff;
    padding-top: 20px;
    opacity: 1;
    font-style: normal;
    font-weight: bold;
    font-size: 36px;
    line-height: 39px;
  }
`

export default Title
